let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eL5Xf")).then(() => parcelRequire('hD5rJ'));